import { rest } from 'msw';
import { getEnv } from 'util/getEnv';
import { offersMessagesData } from './fixtures/customer-app-content.fixture';

export const listCustomerAppContentMock = fn =>
  rest.get(`${getEnv('REACT_APP_ADMIN_API_URL')}/customerappcontent`, fn);

export const handlers = () => [
  listCustomerAppContentMock((_req, res, ctx) => {
    return res(ctx.json(offersMessagesData));
  }),
];
